/* lev: redeploy 2026-07-22 upsell-close-adds-original */
if (typeof jQuery !== "undefined") {
jQuery(document).ready(function($){
  // Legacy script - targets elements from a previous theme/developer
  // All selectors (.split-block__ticker, .custom-video-slider, etc.) are unused
  // Kept wrapped in jQuery check to prevent console errors
});
}

/* ---------------------------------------------------------------------
   Vinyl disclaimer truncation + inline "Read more" toggle.
   Disclaimer divs (.lev-vinyl-disclaimer) are keyword-detected and tagged
   in main-product.liquid + product-details-blocks.liquid.
   Behavior:
     - Collapsed: text clipped to ~140 chars at a word boundary, ends with
       "…" then an inline "Read more" button on the same line.
     - Expanded: full original HTML + inline "Read less" button.
     - Click on either button toggles between the two states.
     - Bold/italics/links in the original richtext are preserved in expanded
       state. Collapsed state uses plain text (predictable truncation).
   --------------------------------------------------------------------- */
(function () {
  var COLLAPSED_LEN = 140;
  var MIN_TO_TRUNCATE = 160; // don't truncate if barely longer

  function escapeHTML(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function setupDisclaimer(el) {
    if (!el || el.dataset.levDisclaimerInit === '1') return;
    el.dataset.levDisclaimerInit = '1';

    var fullHTML = el.innerHTML;
    var fullText = el.textContent.replace(/\s+/g, ' ').trim();
    if (fullText.length < MIN_TO_TRUNCATE) return;

    // Truncate at last space before COLLAPSED_LEN, fall back to hard cut
    var truncated = fullText.slice(0, COLLAPSED_LEN);
    var lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > COLLAPSED_LEN - 40) {
      truncated = truncated.slice(0, lastSpace);
    }
    truncated = truncated.replace(/[.,;:\s]+$/, ''); // trim trailing punct/space

    function render(expanded) {
      var btnLabel = expanded ? 'read less' : 'read more';
      var aria = expanded ? 'true' : 'false';
      var btnHTML = '<button type="button" class="lev-vinyl-disclaimer__toggle" aria-expanded="' + aria + '">' + btnLabel + '</button>';

      if (expanded) {
        el.innerHTML = fullHTML + ' ' + btnHTML;
      } else {
        el.innerHTML = escapeHTML(truncated) +
          '<span class="lev-vinyl-disclaimer__ellipsis">... </span>' +
          btnHTML;
      }
      el.classList.toggle('is-expanded', expanded);

      var btn = el.querySelector('.lev-vinyl-disclaimer__toggle');
      if (btn) {
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          render(!expanded);
        });
      }
    }

    render(false);
  }

  function init() {
    var nodes = document.querySelectorAll('.lev-vinyl-disclaimer');
    for (var i = 0; i < nodes.length; i++) setupDisclaimer(nodes[i]);
  }

  function deferredInit() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(init);
    } else {
      requestAnimationFrame(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferredInit);
  } else {
    deferredInit();
  }
  document.addEventListener('shopify:section:load', deferredInit);
})();

/* ---------------------------------------------------------------------
   Add-to-cart upsell pop-up (Candy-Rack-style).
   Wires onto every <product-form> on a PDP. Reads:
     - <script data-lev-upsell-config> with { product_id, count,
       skip_if_in_cart, labels: {eyebrow,title,add,skip} }
     - 1..N <script data-lev-upsell-offer> entries (in display order)
   On ATC submit (capture phase):
     1. If skip_if_in_cart, filter offers down to those NOT in cart.
     2. If 0 offers remain, let the original submit go through normally.
     3. Otherwise open the modal showing the remaining offers.
   "Add" -> POST /cart/add.js with the original + all selected offers,
            re-render the cart drawer via Volume's own renderContents().
   "Skip" -> resubmit the original form normally (Volume handles it).
   Instrumented with [lev-upsell] console logs so any "popup not firing"
   diagnosis can be done by just opening devtools on the PDP.
   --------------------------------------------------------------------- */
(function () {
  var LOG = function () {
    try {
      var args = ['[lev-upsell]'].concat([].slice.call(arguments));
      console.log.apply(console, args);
    } catch (e) {}
  };
  var POPUP = null;
  var CURRENT = null; // { form, offers, pform }
  var ESCAPED = document.createElement('textarea');

  function getPopup() {
    if (!POPUP) POPUP = document.getElementById('lev-upsell-popup');
    return POPUP;
  }

  function escapeHTML(s) {
    ESCAPED.textContent = String(s == null ? '' : s);
    return ESCAPED.innerHTML;
  }

  // Page-scoped (PDP only) — returns first config on page. Used by init() purely
  // for the diagnostic log when the popup snippet rendered for the current product.
  function readAnyConfig() {
    var node = document.querySelector('script[data-lev-upsell-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); }
    catch (e) { return null; }
  }

  function readConfigFor(productId) {
    if (productId == null) return null;
    var node = document.querySelector('script[data-lev-upsell-config][data-product-id="' + String(productId) + '"]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); }
    catch (e) { return null; }
  }

  function readOffersFor(productId) {
    if (productId == null) return [];
    var out = [];
    document.querySelectorAll('script[data-lev-upsell-offer][data-for-product="' + String(productId) + '"]').forEach(function (n) {
      try {
        var o = JSON.parse(n.textContent || '{}');
        if (o && o.variant_id) out.push(o);
      } catch (e) {}
    });
    return out;
  }

  // Walk DOM up from product-form to find the product's handle for lazy fetch.
  // Tries: closest [data-product-handle] / [data-lev-product-handle] / .card-product link / nearest /products/X link.
  function findProductHandle(pform) {
    if (!pform) return null;
    if (pform.dataset && pform.dataset.productHandle) return pform.dataset.productHandle;
    var withHandle = pform.closest('[data-product-handle], [data-lev-product-handle]');
    if (withHandle) {
      return withHandle.dataset.productHandle || withHandle.dataset.levProductHandle;
    }
    var card = pform.closest('.card-product, .product-card, .card-wrapper, [data-product-id]');
    var scope = card || pform.parentElement || document;
    var link = scope.querySelector ? scope.querySelector('a[href*="/products/"]') : null;
    if (link) {
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  // Lazy-fetch cache: product_id -> Promise (in flight or resolved).
  var LAZY_CACHE = {};

  function lazyFetchOffersFor(productId, productHandle) {
    var key = String(productId);
    if (LAZY_CACHE[key]) return LAZY_CACHE[key];
    if (readConfigFor(productId)) {
      // Already in DOM (perhaps injected by a prior fetch). Mark as resolved.
      LAZY_CACHE[key] = Promise.resolve('cached');
      return LAZY_CACHE[key];
    }
    if (!productHandle) {
      return Promise.resolve('no-handle');
    }
    LOG('lazy-fetch: GET /products/' + productHandle + '?view=upsell-offers (product', productId + ')');
    LAZY_CACHE[key] = fetch('/products/' + encodeURIComponent(productHandle) + '?view=upsell-offers', {
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        // Parse out only the lev-upsell script tags and inject into <body>.
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var injected = 0;
        tmp.querySelectorAll('script[data-lev-upsell-config], script[data-lev-upsell-offer]').forEach(function (s) {
          var clone = document.createElement('script');
          // Mirror all attributes so querySelector picks it up correctly.
          for (var i = 0; i < s.attributes.length; i++) {
            clone.setAttribute(s.attributes[i].name, s.attributes[i].value);
          }
          clone.textContent = s.textContent;
          document.body.appendChild(clone);
          injected++;
        });
        LOG('lazy-fetch: injected', injected, 'script(s) for product', productId);
        return 'fetched';
      })
      .catch(function (e) {
        LOG('lazy-fetch: failed for product', productId, '—', e && e.message);
        delete LAZY_CACHE[key]; // allow retry
        return 'failed';
      });
    return LAZY_CACHE[key];
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      try { return Shopify.formatMoney(cents, theme.moneyFormat); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function renderOfferCards(offers) {
    var host = getPopup() && getPopup().querySelector('[data-lev-upsell-offer-host]');
    if (!host) return;
    host.innerHTML = offers.map(function (offer, i) {
      var compareHTML = '';
      if (offer.compare_at_cents && offer.compare_at_cents > offer.price_cents) {
        compareHTML = ' <s class="lev-upsell-popup__compare">' +
          escapeHTML(formatMoney(offer.compare_at_cents)) + '</s>';
      }
      var image = offer.image
        ? '<img class="lev-upsell-popup__offer-img" src="' + escapeHTML(offer.image) + '" alt="" loading="lazy" width="120" height="120">'
        : '<div class="lev-upsell-popup__offer-img lev-upsell-popup__offer-img--placeholder" aria-hidden="true"></div>';
      var idAttr = 'lev-upsell-offer-' + i;
      return '' +
        '<label class="lev-upsell-popup__offer-link" for="' + idAttr + '" data-lev-upsell-offer-card>' +
          '<input type="checkbox" id="' + idAttr + '" class="lev-upsell-popup__offer-check" data-lev-upsell-offer-check value="' + offer.variant_id + '" checked aria-label="Include in cart">' +
          '<span class="lev-upsell-popup__offer-check-box" aria-hidden="true">' +
            '<svg viewBox="0 0 12 12" width="12" height="12"><path d="M2 6l3 3 5-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' +
          image +
          '<div class="lev-upsell-popup__offer-body">' +
            (offer.vendor ? '<p class="lev-upsell-popup__offer-vendor caption-font">' + escapeHTML(offer.vendor) + '</p>' : '') +
            '<p class="lev-upsell-popup__offer-title body-font">' + escapeHTML(offer.title || '') + '</p>' +
            '<p class="lev-upsell-popup__offer-price body-font">' + escapeHTML(formatMoney(offer.price_cents)) + compareHTML + '</p>' +
          '</div>' +
        '</label>';
    }).join('');
    host.classList.toggle('lev-upsell-popup__offers--multi', offers.length > 1);
    syncCardSelectedStates();
    updateAddButtonState();
  }

  function syncCardSelectedStates() {
    var p = getPopup();
    if (!p) return;
    p.querySelectorAll('[data-lev-upsell-offer-card]').forEach(function (card) {
      var cb = card.querySelector('[data-lev-upsell-offer-check]');
      card.classList.toggle('is-selected', !!(cb && cb.checked));
    });
  }

  function getSelectedOffers() {
    if (!CURRENT) return [];
    var p = getPopup();
    if (!p) return [];
    var selectedIds = {};
    p.querySelectorAll('[data-lev-upsell-offer-check]').forEach(function (cb) {
      if (cb.checked) selectedIds[String(cb.value)] = true;
    });
    return CURRENT.offers.filter(function (o) { return selectedIds[String(o.variant_id)]; });
  }

  function updateAddButtonState() {
    var p = getPopup();
    if (!p) return;
    var addBtn = p.querySelector('[data-lev-upsell-add]');
    if (!addBtn) return;
    var selectedCount = getSelectedOffers().length;
    // When user unchecks every offer, add button becomes a no-op alias for skip.
    // Visually we keep it enabled (label changes), but the click handler routes
    // to resubmitOriginal so they end up with just the original in cart.
    addBtn.dataset.levSelectedCount = String(selectedCount);
  }

  function applyLabels(cfg) {
    var p = getPopup();
    if (!p) return;
    var labels = (cfg && cfg.labels) || {};
    var setText = function (sel, txt) {
      var el = p.querySelector(sel);
      if (el && txt != null) el.textContent = txt;
    };
    setText('[data-lev-upsell-eyebrow]', labels.eyebrow || 'Wait, before you go.');
    setText('[data-lev-upsell-title]', labels.title || 'Pair it with this?');
    setText('[data-lev-upsell-add-label]', labels.add || 'Add all to cart');
    setText('[data-lev-upsell-skip-label]', labels.skip || 'No thanks, just the original');
  }

  function openPopup() {
    var p = getPopup();
    if (!p) return;
    p.hidden = false;
    p.setAttribute('aria-hidden', 'false');
    p.classList.add('is-open');
    document.body.classList.add('lev-upsell-popup-open');
    var focusTarget = p.querySelector('[data-lev-upsell-add]');
    if (focusTarget) try { focusTarget.focus({ preventScroll: false }); } catch (e) { focusTarget.focus(); }
    document.addEventListener('keydown', onKeydown, true);
  }

  function closePopup() {
    var p = getPopup();
    if (!p) return;
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
    p.hidden = true;
    document.body.classList.remove('lev-upsell-popup-open');
    document.removeEventListener('keydown', onKeydown, true);
    if (CURRENT && CURRENT.pform) restoreSubmitButton(CURRENT.pform);
    CURRENT = null;
    setBusy(false);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      // Dismissing the offer must NEVER cancel the customer's add. Escape adds
      // the original item (same as the "no thanks" skip path).
      dismissAndAddOriginal();
    }
  }

  // Close/dismiss the upsell popup while still adding the customer's original
  // item (so the popup can never block an add-to-cart). Mirrors the skip path.
  function dismissAndAddOriginal() {
    if (!CURRENT) { closePopup(); return; }
    var form = CURRENT.form;
    closePopup();
    resubmitOriginal(form);
  }

  function setBusy(busy) {
    var p = getPopup();
    if (!p) return;
    var addBtn = p.querySelector('[data-lev-upsell-add]');
    var skipBtn = p.querySelector('[data-lev-upsell-skip]');
    var spinner = p.querySelector('.lev-upsell-popup__add-spinner');
    if (addBtn) addBtn.setAttribute('aria-disabled', busy ? 'true' : 'false');
    if (addBtn) addBtn.classList.toggle('loading', !!busy);
    if (skipBtn) skipBtn.disabled = !!busy;
    if (spinner) spinner.hidden = !busy;
  }

  function restoreSubmitButton(pform) {
    if (!pform) return;
    var btn = pform.querySelector('[type="submit"]');
    if (btn) {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
    }
    var spin = pform.querySelector('.loading-overlay__spinner');
    if (spin) spin.classList.add('hidden');
  }

  function fetchCartProductIds() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = new Set();
        (cart && cart.items ? cart.items : []).forEach(function (i) {
          if (i.product_id != null) ids.add(String(i.product_id));
        });
        return ids;
      })
      .catch(function () { return new Set(); });
  }

  function getSectionsParam() {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = [];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try {
        sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {}
    }
    var unique = [];
    var seen = {};
    sections.forEach(function (id) { if (!seen[id]) { seen[id] = 1; unique.push(id); } });
    return { cart: cart, sections: unique };
  }

  function reRenderCart(cart, response) {
    if (cart && typeof cart.renderContents === 'function') {
      try { cart.renderContents(response); } catch (e) {}
    }
  }

  function addAllToCart(form, offers) {
    setBusy(true);
    var origVariantInput = form.querySelector('[name="id"]');
    var origQtyInput = form.querySelector('[name="quantity"]');
    var origVariantId = origVariantInput ? origVariantInput.value : null;
    var origQty = (origQtyInput && parseInt(origQtyInput.value, 10)) || 1;
    if (!origVariantId) {
      setBusy(false);
      return resubmitOriginal(form);
    }
    var ctx = getSectionsParam();
    var fd = new FormData();
    fd.append('items[0][id]', origVariantId);
    fd.append('items[0][quantity]', String(origQty));
    offers.forEach(function (offer, i) {
      var idx = i + 1;
      fd.append('items[' + idx + '][id]', String(offer.variant_id));
      fd.append('items[' + idx + '][quantity]', '1');
    });
    if (ctx.sections.length) {
      fd.append('sections', ctx.sections.join(','));
      fd.append('sections_url', window.location.pathname);
    }
    document.dispatchEvent(new CustomEvent('cart:add:start'));
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response && response.status) {
          closePopup();
          document.dispatchEvent(new CustomEvent('cart:add:error'));
          return resubmitOriginal(form);
        }
        if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lev-upsell-popup' }); } catch (e) {}
        }
        reRenderCart(ctx.cart, response);
        document.dispatchEvent(new CustomEvent('cart:add:success'));
        closePopup();
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart:add:error'));
        closePopup();
        resubmitOriginal(form);
      });
  }

  function resubmitOriginal(form) {
    var pform = form.closest('product-form');
    if (pform) pform.dataset.levUpsellSkip = '1';
    // Defer out of the current submit-event dispatch. When this is reached
    // synchronously from onSubmitCapture (0-offer products, e.g. new pre-orders),
    // a re-entrant requestSubmit()/submit() is a spec no-op because the form's
    // "firing submission events" flag is still true — silently dropping the add
    // (the "have to click Pre-order twice" bug). setTimeout(0) lets the original
    // submit finish first so the resubmit actually runs and Volume adds.
    setTimeout(function () {
      try {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      } catch (e) {
        form.submit();
      }
      setTimeout(function () { if (pform) delete pform.dataset.levUpsellSkip; }, 800);
    }, 0);
  }

  function getProductIdFromForm(pform) {
    if (!pform) return null;
    if (pform.dataset && pform.dataset.productId) return pform.dataset.productId;
    var formEl = pform.querySelector ? pform.querySelector('form[data-productid]') : null;
    if (formEl && formEl.dataset.productid) return formEl.dataset.productid;
    return null;
  }

  function onSubmitCapture(e) {
    var pform = e.currentTarget;
    if (pform.dataset.levUpsellSkip === '1') {
      LOG('intercept: skip flag set on this product-form — passing through to Volume');
      return;
    }
    var form = e.target;
    if (!form || form.tagName !== 'FORM') {
      LOG('intercept: submit target is not a <form>:', form);
      return;
    }
    var productId = getProductIdFromForm(pform);
    if (!productId) {
      LOG('intercept: could not resolve product id on this product-form — passing through');
      return;
    }

    // Already have config for this product in DOM (PDP-rendered or previously lazy-fetched)
    var cfg = readConfigFor(productId);
    if (cfg) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return proceedWithOffers(form, pform, productId, cfg);
    }

    // No config yet — try lazy fetch via /products/{handle}?view=upsell-offers
    var handle = (cfg && cfg.handle) || findProductHandle(pform);
    if (!handle) {
      LOG('intercept: no config + no resolvable product handle — passing through. Mark the product card with [data-product-handle] or wrap a <a href="/products/X"> if you want non-PDP coverage.');
      return;
    }
    // Optimistically intercept so the submit doesn't race the fetch.
    e.preventDefault();
    e.stopImmediatePropagation();
    LOG('intercept: no inline config for product', productId, '— lazy-fetching via product handle "' + handle + '"');
    lazyFetchOffersFor(productId, handle).then(function (status) {
      var resolvedCfg = readConfigFor(productId);
      if (!resolvedCfg) {
        LOG('intercept: lazy fetch resolved (' + status + ') but no usable offers for product', productId, '— resubmitting original normally');
        resubmitOriginal(form);
        return;
      }
      proceedWithOffers(form, pform, productId, resolvedCfg);
    });
  }

  function proceedWithOffers(form, pform, productId, cfg) {
    var offers = readOffersFor(productId);
    if (offers.length === 0) {
      LOG('intercept: config present but 0 offer scripts for product', productId, '— this product has no usable complementary/related entries (after sold-out + self-filter). Resubmitting original normally.');
      resubmitOriginal(form);
      return;
    }
    var force = isForceMode();
    if (force) LOG('FORCE mode active (?lev_upsell=force) — bypassing skip_if_in_cart filter');
    LOG('intercept: halted Volume submit. Fetching /cart.js to filter in-cart offers…');
    fetchCartProductIds().then(function (inCart) {
      LOG('cart product_ids:', Array.from(inCart));
      var visible = offers;
      if (cfg.skip_if_in_cart && !force) {
        var before = offers.length;
        visible = offers.filter(function (o) { return !inCart.has(String(o.product_id)); });
        if (visible.length < before) {
          LOG('skip_if_in_cart filtered', before - visible.length, 'of', before, 'offers (already in cart)');
        }
      }
      if (visible.length === 0) {
        LOG('ALL offers already in cart — popup intentionally skipped, resubmitting original normally. Append ?lev_upsell=force to URL to bypass this filter.');
        resubmitOriginal(form);
        return;
      }
      LOG('showing popup with', visible.length, 'offer(s):', visible.map(function (o) { return o.title; }));
      CURRENT = { form: form, offers: visible, pform: pform };
      applyLabels(cfg);
      renderOfferCards(visible);
      openPopup();
    });
  }

  function isForceMode() {
    try {
      return /[?&]lev_upsell=force(&|$)/.test(window.location.search);
    } catch (e) { return false; }
  }

  function wireForm(pform) {
    if (!pform || pform.dataset.levUpsellWired === '1') return;
    pform.dataset.levUpsellWired = '1';
    pform.addEventListener('submit', onSubmitCapture, true);
  }

  function onPopupClick(e) {
    if (e.target.closest('[data-lev-upsell-close]')) { dismissAndAddOriginal(); return; }
    if (e.target.closest('[data-lev-upsell-skip]')) { dismissAndAddOriginal(); return; }
    if (e.target.closest('[data-lev-upsell-add]')) {
      if (!CURRENT) { closePopup(); return; }
      var selected = getSelectedOffers();
      if (selected.length === 0) {
        // No offers selected -> behave like "No thanks": original only.
        var form = CURRENT.form;
        closePopup();
        resubmitOriginal(form);
        return;
      }
      addAllToCart(CURRENT.form, selected);
      return;
    }
  }

  function onPopupChange(e) {
    if (e.target && e.target.matches && e.target.matches('[data-lev-upsell-offer-check]')) {
      syncCardSelectedStates();
      updateAddButtonState();
    }
  }

  function init() {
    var popup = getPopup();
    if (!popup) {
      LOG('init: modal shell #lev-upsell-popup not in DOM — snippet not rendered in theme.liquid. Bailing.');
      return;
    }
    if (!popup.dataset.levUpsellPopupWired) {
      popup.dataset.levUpsellPopupWired = '1';
      popup.addEventListener('click', onPopupClick);
      popup.addEventListener('change', onPopupChange);
    }

    var inlineCfg = readAnyConfig();
    if (inlineCfg) {
      var offerCount = document.querySelectorAll('script[data-lev-upsell-offer][data-for-product="' + String(inlineCfg.product_id) + '"]').length;
      LOG('init: inline config found for product', inlineCfg.product_id, '| offer scripts:', offerCount, '| count cap:', inlineCfg.count, '| skip_if_in_cart:', inlineCfg.skip_if_in_cart);
    } else {
      LOG('init: no inline config (non-PDP). Non-PDP ATC clicks will lazy-fetch offer data via /products/{handle}?view=upsell-offers.');
    }

    var pforms = document.querySelectorAll('product-form');
    pforms.forEach(wireForm);
    LOG('init: wired', pforms.length, 'product-form element(s). Capture-phase submit listener active.');
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('product-form')) wireForm(n);
          if (n.querySelectorAll) n.querySelectorAll('product-form').forEach(wireForm);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ---------------------------------------------------------------------
   Smart category menu: smooth load entrance + sticky collapse/expand.
   LOAD: bar pre-hidden (opacity 0) in theme.liquid <head> before paint; we
   add .lev-cat-ready to <html> so the CSS fades it in (no flash).
   COLLAPSE: theme animates `.main-header { max-height; transition 0.25s }` on
   `header--collapsed`, sliding the bar. Repositioning live reads as a "jerk"
   and the bar's border lines snap (no native transition). We hide menu + lines
   through the slide, then glide + fade them in together.
   Hardened against rapid toggles: a SINGLE shared restore timer (cleared on
   each new fade) so overlapping collapse/expand events can never pile up or
   leave the bar stuck invisible. It reveals once, 250ms after the last toggle.
   Added 2026-06-04; durations tunable below.
   --------------------------------------------------------------------- */
(function () {
  var header = document.querySelector('.shopify-section-header');
  if (!header) {
    try { document.documentElement.classList.add('lev-cat-ready'); } catch (e) {}
    return;
  }

  var SETTLE_MS = 250;   // match the theme's .main-header max-height transition
  var GLIDE_MS  = 380;   // collapse fade + glide-in duration
  var restoreTimer = null;

  function smartMenus() {
    return document.querySelectorAll('.bottom-bar-wrapper .menu, .bottom-bar__main-nav');
  }
  var bottomBar = header.querySelector('.bottom-bar');
  var origTop = null, origBot = null;
  if (bottomBar) {
    var cs = getComputedStyle(bottomBar);
    origTop = cs.borderTopColor;
    origBot = cs.borderBottomColor;
  }

  /* LOAD reveal. */
  requestAnimationFrame(function () {
    document.documentElement.classList.add('lev-cat-ready');
  });

  function hideNow(menus) {
    menus.forEach(function (m) {
      m.style.transition = 'none';
      m.style.opacity = '0';
      m.style.transform = 'translateY(6px)';
    });
    if (bottomBar) {
      bottomBar.style.transition = 'none';
      bottomBar.style.borderTopColor = 'transparent';
      bottomBar.style.borderBottomColor = 'transparent';
    }
  }
  function restore() {
    smartMenus().forEach(function (m) {
      m.style.transition = 'opacity ' + GLIDE_MS + 'ms ease, transform ' + GLIDE_MS + 'ms ease';
      m.style.opacity = '1';
      m.style.transform = 'translateY(0)';
    });
    if (bottomBar) {
      bottomBar.style.transition = 'border-color ' + GLIDE_MS + 'ms ease';
      bottomBar.style.borderTopColor = origTop;
      bottomBar.style.borderBottomColor = origBot;
    }
  }

  function fadeThroughReposition() {
    var menus = smartMenus();
    if (!menus.length) return;
    hideNow(menus);
    void menus[0].offsetWidth; // force reflow so the hidden start state applies now
    // Single shared timer: rapid toggles keep pushing the reveal back, so the
    // bar stays hidden through the burst and reveals exactly once afterward.
    clearTimeout(restoreTimer);
    restoreTimer = setTimeout(restore, SETTLE_MS);
  }

  var lastCollapsed = header.classList.contains('header--collapsed');
  new MutationObserver(function () {
    var nowCollapsed = header.classList.contains('header--collapsed');
    if (nowCollapsed !== lastCollapsed) {
      lastCollapsed = nowCollapsed;
      fadeThroughReposition();
    }
  }).observe(header, { attributes: true, attributeFilter: ['class'] });
})();
